// src/pages/booking/components/CustomPicker.js
import React, { useState, useEffect } from 'react';
import { Popup, PickerView, Button } from 'antd-mobile';

const CustomPicker = ({
  visible,
  onClose,
  onConfirm,
  title = '選擇',
  columns = [],
  defaultValue = '',
}) => {
  const [value, setValue] = useState(defaultValue);

  // 當 defaultValue 改變時，同步更新本地 state
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Popup visible={visible} onMaskClick={onClose} bodyStyle={{ borderRadius: '16px 16px 0 0' }}>
      <div className="custom-picker-popup">
        <div className="picker-header">{title}</div>
        <PickerView
          columns={[columns]} 
          value={[value]}
          onChange={(val) => setValue(val[0])}
        />
        <div className="picker-footer">
          <Button className="cancel-btn" onClick={onClose}>
            取消
          </Button>
          <Button
            className="confirm-btn"
            onClick={() => {
              onConfirm(value);
              onClose();
            }}
          >
            確定
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default CustomPicker;
